import { AxiosError } from 'axios';
import api from '../../../services/api';
import { FunctionFormProps } from '../types/function.type';

export async function editFunctionRequest({ ...rest }: FunctionFormProps) {
	try {
		const response = await api.put('/function', {
			...rest,
		});

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
